import _ from 'lodash';
import { Tooltip } from '@material-ui/core';
import { INCIDENTS_MODEL } from '../../incidents.model';
import { StyledCell, StyledLink } from '../Table.style';
import styled from 'styled-components';

const TITLE_MAX_LENGTH = 50;

const StyledTooltip = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 50rem;
  overflow-wrap: anywhere;
`;

const AccidentTooltip = ({ title, providerId }) => {
  return (
    <StyledTooltip>
      {title} ({providerId})
    </StyledTooltip>
  );
};

const IncidentCell = ({ incident }) => {
  const title = _.get(incident, INCIDENTS_MODEL.TITLE, '');
  const providerId = _.get(incident, INCIDENTS_MODEL.PROVIER_ID, '');
  const url = _.get(incident, INCIDENTS_MODEL.URL);

  const titleWithProviderId = `${title} (${providerId})`;

  const isTitleTooLong = titleWithProviderId.length > TITLE_MAX_LENGTH;
  const titleInView = isTitleTooLong
    ? `${titleWithProviderId.substring(0, TITLE_MAX_LENGTH)}...`
    : titleWithProviderId;

  return (
    <StyledCell>
      {url ? (
        <Tooltip
          title={
            isTitleTooLong ? (
              <AccidentTooltip
                title={isTitleTooLong && title}
                providerId={providerId}
              />
            ) : (
              ''
            )
          }
          placement='top-start'
        >
          <StyledLink target='_blank' href={url}>
            {titleInView}
          </StyledLink>
        </Tooltip>
      ) : (
        <span>{title}</span>
      )}
    </StyledCell>
  );
};

export default IncidentCell;
